(function () {
    angular
        .module('app.ocom')
        .directive("ocomTags", ['$filter',  function($filter) {
            return {
                restrict: 'AE',
                require: 'ngModel',
                scope: {
                    ocomTags: "=",
                    ngModel: '=',
                    title: '@?',
                    onChange: "&",
                    ngDisabled: "="
                },
                templateUrl: "js/ocom/widgets/forms/ocom-tags.directive.html",
                link: function (scope, elem, attrs, ngModel) {

                    function updateTheValue () {
                        if (ngModel.$modelValue) {
                            var newValue = [];

                            if (scope.tagsMap) {
                                var newValue = _.map(ngModel.$modelValue, function (id) {
                                    return scope.tagsMap[id];
                                });
                            }

                            scope.value = newValue;
                        }
                    }

                    scope.$watch('ocomTags', function (newVal, oldVal) {
                        if (newVal) {

                            scope.tagsMap = _.keyBy(newVal, "id")

                            updateTheValue();
                        }
                        else {
                            scope.tagsMap = {};
                        }
                    });

                    scope.selectChanged = function (value) {
                        // scope.$apply(function() {
                        if (angular.isDefined(value)) {

                            var returnValue = _.uniq(_.map(value, function (item) {
                               return item.id;
                            }));

                            ngModel.$setViewValue(returnValue);
                            //scope.value = _.find(scope.items, {'Code': ngModel.$modelValue});
                            if (scope.onChange) {
                                scope.onChange(returnValue); // Notify
                            }
                        }
                        updateTheValue();
                    };

                    ngModel.$render = function() {
                        updateTheValue();
                    };
                }
            }
        }]);
})();